const base = {
    baseUrl: "",
    wechatRedirectUrl: "/login/weChatLogin?url={0}",
    getMyRole: "/api/role/getMyRole",
    wechatCodeLogin: "/login/getUserTokenByCode?code={0}",
    loginCaptchaToken: "/login/captchaToken",

    userInfo: "/api/sale/myInfo",
    login: "/login/accountLogin",
    logout: "/api/user/logout?channel=1&env={0}",
    filters: {
        0: '/api/channel/getChannelDataQueryForm',
    },
    getOssKeySecret: "/api/oss/getOssKeySecret",
    getH5DashboardData: "/api/statistic/h5dashboardData",
    getStatisticData: "/api/channel/queryChannelData",
    getWechatRedirectUrl: "/login/weChatLogin?url={0}",

    applySmsCaptcha: "/api/sale/applySmsBind?phone={0}",
    applySmsBind: "/api/sale/bindPhone",
    getAgentSaleId: "/api/sale/getAgentSaleId?goodId={0}",
    getSaleGood: "/api/sale/getSaleGood?goodId={0}",
    getSkuInfo: "/api/sale/getSkuInfo?skuId={0}",
    getRecentOrderList: "/api/sale/getRecentOrderList?goodId={0}",
    createPayOrder: "/api/sale/createPayOrder",
    getSaleOrder: "/api/sale/getSaleOrder?orderId={0}",
    updateSaleOrderInfo: "/api/sale/updateSaleOrderInfo",
    submitForgetPassword: "/api/sale/forgetPayPass",
    submitResetPayPassSmsVerify: "/api/sale/forgetPayPassReset",
    getPasswordInputToken: "/api/sale/getPasswordInputToken?scene={0}",

    getPersonalAgentReportDetail: "/api/sale/getPersonalAgentReportDetail",
    getSaleCategory: "/api/sale/category/list4select",
    confirmInnerLianLianPay: "/open/llp/inner/pay",
    getOpenSaleOrder: "/open/llp/inner/getOrderByOrderId",
    getPasswordToken: "/api/sale/getWithdrawPasswordToken",
    queryAccount: "/api/sale/queryAccount",
    submitApplyWithdraw: "/api/sale/withdraw",
    submitSmsVerify: "/api/sale/smsVerify",
    getOpenLLPAccountLink: "/api/sale/getOpenLLPAccountLink",
    submitRealName4Withdraw: "/api/sale/submitRealName4Withdraw",

    getAgentList: "/api/sale/getAgentList",
    getGoodList4Select: "/api/sale/goods/list4select",
    getBalancePayConfig: "/open/llp/inner/getBalancePayConfig",
    balancePaySmsVerify: "/open/llp/inner/balancePaySmsVerify",
    getAgentSaleOrder: "/api/sale/getSaleAgentOrder",
    refundSaleOrder: "/api/sale/refundSaleOrder",
    confirmShareProfit: "/api/sale/profitSharing",
    profitSharingRollback: "/api/sale/profitSharingRollback",

    getEnumOptions: "/api/sale/setting/list",
    auditRefund: "/api/sale/refund/audit/audit",
    getCorpBalance: "/api/sale/getCorpBalance",
    getRefundHistory: "/api/sale/refund/audit/getOrderRefundList?recordId={0}",

    infiniteLoadings: {
        1:'/api/sale/list',
        2:'/api/sale/myOrderList',
        3:'/api/sale/agentOrderList',
        4:'/api/sale/share/list',
        5:'/api/sale/refund/audit/list',
    }

}

export default base;